import { SxProps, Theme } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';
import { DESKTOP_MIN_WIDTH } from '../constants';

export const productBrandAndNameSX = (isProductList = false): SxProps<Theme> => ({
	WebkitLineClamp: '3',
	display: '-webkit-box',
	WebkitBoxOrient: 'vertical',
	overflow: 'hidden',
	textTransform: 'uppercase',
	lineHeight: '1.2',
	height: '67px',

	[`@media (min-width: ${DESKTOP_MIN_WIDTH}px)`]: {
		height: 'auto',
	},
	...(isProductList && {
		color: 'grey.500',
		'& a': { color: 'grey.500' },
	}),
});

export const productBrandAndNameBundleSX: SxProps<Theme> = {
	maxHeight: '56px',
	textTransform: 'none',
};

export const productBrandSx: SxProps<Theme> = {
	fontWeight: OpenSansFontWeights.bold,
};

export const productNameSx: SxProps<Theme> = {
	'&:hover': {
		textDecoration: 'underline',
	},
};
